import ParagraphBoundaryPolicy from "./ParagraphBoundaryPolicy";
import ParagraphLayoutBehavior from "./ParagraphLayoutBehavior";

function normalizeRuleArray(rules){
    if(!Array.isArray(rules)){
        return [];
    }
    return rules.filter((rule)=>{
        return typeof rule === "function";
    });
}

function isStartWrapNodeType(nodeType){
    return typeof nodeType === "string" && /^Start.*WrapSequencerNode$/.test(nodeType);
}

const DEFAULT_RULES = Object.freeze({
    behaviorRules: Object.freeze([
        ParagraphBoundaryPolicy.ruleFactories.resolveNodeProvidedBehavior,
        ParagraphBoundaryPolicy.ruleFactories.extendBehaviorForNodeType(
            isStartWrapNodeType,
            ParagraphLayoutBehavior.presets.associateWithNextParagraph(),
        ),
        ParagraphBoundaryPolicy.ruleFactories.extendBehaviorForNodeType(
            "DeletedSequencerNode",
            ParagraphLayoutBehavior.presets.associateWithNextParagraph(),
        ),
        ParagraphBoundaryPolicy.ruleFactories.extendBehaviorForNodeType("StartLayoutWrapSequencerNode", {
            breakBefore: true,
            breakBeforeReason: "layout-wrap-start",
            breakBeforeStrength: ParagraphBoundaryPolicy.BREAK_STRENGTH.HARD,
        }),
        ParagraphBoundaryPolicy.ruleFactories.extendBehaviorForNodeType("EndLayoutWrapSequencerNode", {
            breakAfter: true,
            breakAfterReason: "layout-wrap-end",
            breakAfterStrength: ParagraphBoundaryPolicy.BREAK_STRENGTH.HARD,
        }),
        ParagraphBoundaryPolicy.ruleFactories.extendBehaviorForNodeType(
            "LayoutSequencerNode",
            ParagraphLayoutBehavior.presets.isolatedUnlabeledParagraph(null, {
                breakBeforeReason: "layout-node-isolated",
                breakAfterReason: "layout-node-isolated",
                breakBeforeStrength: ParagraphBoundaryPolicy.BREAK_STRENGTH.HARD,
                breakAfterStrength: ParagraphBoundaryPolicy.BREAK_STRENGTH.HARD,
            }),
        ),
        ParagraphBoundaryPolicy.ruleFactories.breakAfterLongPause,
    ]),
    deferRules: Object.freeze([
        ParagraphBoundaryPolicy.ruleFactories.deferNextAffinityNodes,
    ]),
    breakRules: Object.freeze([
        ParagraphBoundaryPolicy.ruleFactories.breakWhenMissingCurrentParagraph,
        ParagraphBoundaryPolicy.ruleFactories.breakWhenPendingBoundary,
        ParagraphBoundaryPolicy.ruleFactories.breakWhenNodeDemandsBoundary,
        ParagraphBoundaryPolicy.ruleFactories.breakWhenParagraphCannotAcceptNodes,
    ]),
});

const DEFAULT_PARAGRAPH_BOUNDARY_POLICY_FOR_SEQUENCER = ParagraphBoundaryPolicy.create(DEFAULT_RULES);

function createParagraphBoundaryPolicyForSequencer(customRules){
    if(!customRules){
        return DEFAULT_PARAGRAPH_BOUNDARY_POLICY_FOR_SEQUENCER;
    }

    return ParagraphBoundaryPolicy.create({
        behaviorRules: DEFAULT_RULES.behaviorRules.concat(normalizeRuleArray(customRules.behaviorRules)),
        deferRules: normalizeRuleArray(customRules.deferRules).concat(DEFAULT_RULES.deferRules),
        breakRules: normalizeRuleArray(customRules.breakRules).concat(DEFAULT_RULES.breakRules),
    });
}

createParagraphBoundaryPolicyForSequencer.DEFAULT_RULES = DEFAULT_RULES;
createParagraphBoundaryPolicyForSequencer.defaultPolicy = DEFAULT_PARAGRAPH_BOUNDARY_POLICY_FOR_SEQUENCER;

export default createParagraphBoundaryPolicyForSequencer;
